import Index from './Index'
import ChatWindow from './ChatWindow'

export default {
    Index,
    ChatWindow
}
